/* eslint-disable import/no-unresolved */
import styled, { css } from 'styled-components';

import 'swiper/css';
import 'swiper/css/navigation';

export const Container = styled.div`
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 1240px;
    margin: 0 auto;
  }
`;

export const Content = styled.div``;

export const DesktopItems = styled.div`
  display: grid;
  grid-template-columns: 300px repeat(2, minmax(350px, 457px));
  grid-template-rows: repeat(2, 251px);
  gap: 13px;
  overflow: unset;
`;

export const Item = styled.div<{ takeFullHeight: boolean }>`
  height: 100%;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.gray87};
  overflow: hidden;

  & a {
    display: block;
    height: 100%;
  }

  ${({ takeFullHeight }) =>
    takeFullHeight
      ? css`
          grid-row: 1/-1;
        `
      : ''}
`;

export const ShowAllItems = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 10px 0 auto;
  width: fit-content;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: unset;
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Wrapper = styled.div`
  .swiper-button-next,
  .swiper-button-prev {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50px;
    color: white;
    width: 50px;
    height: 50px;
    border: 2px solid ${({ theme }) => theme.palette.white};
    ::after {
      font-size: 32px;
    }
    :hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  .swiper-button-disabled {
    opacity: 0.35;
    cursor: unset;
    pointer-events: unset !important;
  }
  .swiper-slide {
    height: 274px;
  }
`;
